<template>
  <div class="live_detail">
    <MobileHead />
    <div class="liveDetail">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/index' }">{{ $t('navbar.home') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/live' }">{{ $t('navbar.live') }}</el-breadcrumb-item>
          <el-breadcrumb-item :style="{ maxWidth: lang == 'zh' ? '55vw' : '42vw' }"
            ><a href="/active_detail" span style="color:#006FB8; font-weight: 400;">{{ sizeForm.liveCn }}</a></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="liveContent">
        <div class="vedio">
          <video
            :src="sizeForm.videoAddress"
            class="shipin"
            controls="controls"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-video-orientation="portraint"
            v-if="sizeForm.videoAddress.substr(0,4) == 'http'"
          ></video>
          <video
            :src="baseUrl + sizeForm.videoAddress"
            class="shipin"
            controls="controls"
            webkit-playsinline="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-video-orientation="portraint"
            v-else
          ></video>
        </div>
      </div>
      <div class="companyDetail">
        <div class="companyName">
          <div class="left">{{ sizeForm.liveCn }}</div>
        </div>

        <div class="exhibitor" @click="goDetail()">
          <div class="logo">
            <img :src="shopForm.comCover" alt="" v-if="shopForm.comCover.substr(0,4)=='http'" />
            <img :src="baseUrl + shopForm.comCover" alt="" v-else />
          </div>
          <div class="exhi_title">
            <p :title="shopForm.companyNameC">{{ shopForm.companyNameC }}</p>
            <p :title="boothNum" v-if="boothNum" class="booths">
              {{ $t('common.boothNum1')
              }}<span style="color: #333333;font-size :16px;font-weight:600" v-for="(item, index) in boothNum" :key="index">{{ item }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="itemInfo">
        <div id="item1">
          <h3 :style="{ width: lang == 'zh' ? '24.27vw' : '57vw' }">{{ $t('live.liveIntroduce') }}</h3>
          <p>{{ sizeForm.liveIntroductionCn }}</p>
        </div>
      </div>
    </div>
    <div class="fun">
      <div class="collent_btn">
        <button class="shoucang3" @click="getshou" v-if="sizeForm.collectStatus">{{ $t('common.collected') }}</button>
        <button class="shoucang2" @click="getshou" v-else>{{ $t('common.collectLive') }}</button>
        <div class="share" @click="goShare">
          <div class="shareLogo"><img src="../../../static/share.png" alt="" /></div>
          <div class="shareTxt">{{ $t('common.share') }}</div>
        </div>
      </div>
    </div>
    <Share
      :shareVisiable="shareVisiable"
      @copyLink="copyLink"
      @closePannel="closePannel"
      :shareContentTitle="shareContentTitle"
      :shareContentUrl="shareContentUrl"
    />
    <GoLogin :dialogVisible.sync="dialogVisible" @func="getMsgFormSon" @funcancel="getCancel" />
    <Foot style="margin-bottom:15.2vw" />
  </div>
</template>

<script>
import MobileHead from '../../../common/mobile/head.vue';
import Foot from '../../../common/mobile/footBottom.vue';
import { forMat } from '../../../../utils/common.js';
import { getLiveDetail, getShopDetail, getShoucang } from '../../../../api/livePage';
import * as tools from '../../../../utils/roulink';
import Share from '../../../common/mobile/share.vue';
import GoLogin from '../../../common/mobile/goLogin.vue'; //登录提示框

export default {
  name: '',
  components: { MobileHead, Foot, Share, GoLogin },

  data() {
    return {
      baseUrl: forMat(),
      // 直播数据
      sizeForm: {},
      id: this.$route.query.userId,
      // 展商数据
      shopForm: {},
      boothNum: [],
      lang: '',
      shareVisiable: false,
      shareContentTitle: '',
      shareContentUrl: '',
      dialogVisible: false,
    };
  },
  created() {
    document.documentElement.scrollTop = 0;

    this.getDetails(this.id);
    this.lang = localStorage.getItem('lang');
  },
  methods: {
    getCancel(data) {
      this.dialogVisible = data;
    },
    getMsgFormSon(data) {
      this.dialogVisible = data;
      tools.login(3);
    },
    // 复制链接
    closePannel(data) {
      this.shareVisiable = data;
    },
    copyLink() {},
    goShare() {
      this.shareVisiable = true;
      this.shareContentTitle = this.sizeForm.liveCn;
      this.shareContentUrl = window.location.href;
    },
    // 根据id获取详情数据
    async getDetails(val) {
      const data = await getLiveDetail({ id: val });
      this.sizeForm = data.data.data[0];
      // 简介内容去掉<p>标签
      let str = this.sizeForm.liveIntroductionCn;
      str = str.replace(/<([a-zA-Z1-6]+)(\s*[^>]*)?>/g, '');
      str = str.replace(/<(\/[a-zA-Z1-6]+)(\s*[^>]*)?>/g, '');
      this.sizeForm.liveIntroductionCn = str;
      // 获取展商信息
      const shop = await getShopDetail({ id: this.sizeForm.hzexhibitorId });
      this.shopForm = shop.data.data;
      console.log(this.shopForm);
      this.shopForm.hzBoothList.map((item) => {
        this.boothNum.push(item.boothNum);
      });
    },
    // 收藏直播
    async getshou() {
      const shouDetail = {
        objId: this.id,
        flag: !this.sizeForm.collectStatus,
        type: 3,
      };
      try {
        const { data } = await getShoucang(shouDetail);
        if (data.code === 200) {
          this.sizeForm.collectStatus = !this.sizeForm.collectStatus;
          this.exForm.collectStatus = !this.exForm.collectStatus;
          const toggleStatus = this.exForm.collectStatus === true ? true : false;
          if (toggleStatus === true) {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'error',
            });
          }
        } else {
          this.dialogVisible = true;
        }
      } catch (err) {
        if (err == 'noLogin') {
          this.dialogVisible = true;
        }
      }
    },
    // 跳转展商详情
    goDetail() {
      this.$router.push({
        name: 'exhibition_det',
        query: {
          id: this.sizeForm.hzexhibitorId,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.live_detail {
  .liveDetail {
    width: 100%;
    margin: 13.3vw auto;
    .nav {
      padding: 4vw;
      box-sizing: border-box;
    }
    .liveContent {
      margin-top: 6.4vw;
      padding-left: 4vw;
      padding-right: 4vw;
      box-sizing: border-box;
      .vedio {
        height: 51.73vw;
        margin: 0 auto;
        margin-top: 6.4vw;
        .shipin {
          width: 100%;
          height: 51.73vw;
        }
      }
    }
    .companyDetail {
      width: 100%;
      margin-top: 6.5vw;
      padding-left: 4vw;
      padding-right: 4vw;
      box-sizing: border-box;
      .companyName {
        width: 100%;
        height: 6vw;
        .left {
          font-size: 4.8vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 6vw;
        }
      }
      .exhibitor {
        width: 100%;
        height: 22.9vw;
        display: flex;
        margin-top: 10.67vw;
        border: 1px solid #e0e0e0;

        .logo {
          width: 29.87vw;
          height: 22.9vw;
          //padding: 0 56px;
          box-sizing: border-box;
          border-right: 1px solid #e0e0e0;
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2.6vw 4.8vw;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
        .exhi_title {
          box-sizing: border-box;
          padding: 4vw;
          flex: 1;
          display: flex;
          box-sizing: border-box;
          flex-direction: column;
          justify-content: space-between;
          p {
            max-width: 44.7vw;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            font-size: 3.7vw;
          }
          .boothnum {
          }
          .booths {
            width: 44.7vw;
            max-width: 44.7vw;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }
        }
      }
    }
    .itemInfo {
      // 展商介绍

      h3 {
        font-size: 4.8vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-bottom: 6.4vw;
        color: #006fb8;
        width: 24.27vw;
        border-left: 0.4vw solid #006fb8;
        border-right: 0.4vw solid #006fb8;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 4.8vw;
      }
      #item1 {
        margin-top: 10.67vw;
        padding-left: 4vw;
        padding-right: 4vw;
        box-sizing: border-box;
        p {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 3.7vw;
          color: #333333;
        }
      }
    }
  }
  .fun {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 15.2vw;
    background: #ffffff;
    box-shadow: 0px 0px 13.3vw 0px rgba(109, 109, 109, 0.35);
    z-index: 99;
    padding: 2.6vw 4vw;
    box-sizing: border-box;
    .collent_btn {
      display: flex;
      button {
        cursor: pointer;
      }

      .shoucang2 {
        border: none;
        width: 77vw;
        height: 9.6vw;
        background: #fdd000;
        border-radius: 4px;
        color: #006fb8;
        font-size: 4.3vw;
        margin-left: 2.6vw;
        &:hover {
          background: #fdd933;
        }
        &:active {
          background: #e4bb00;
        }
      }

      .shoucang3 {
        background: #ededed;
        border: none;
        width: 77vw;
        height: 9.6vw;
        border-radius: 4px;
        color: white;
        font-size: 4.3vw;
        margin-left: 2.6vw;
        &:hover {
          background: #ededed;
        }
      }

      .share {
        margin-left: 5.3vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .shareLogo {
          width: 100%;
          height: 4.8vw;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        img {
          color: #666666;
          max-width: 100%;
          max-height: 100%;
          vertical-align: middle;
        }
        .shareTxt {
          font-size: 3.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
}
</style>
<style scoped>
.el-breadcrumb__item >>> .el-breadcrumb__inner {
  color: #333 !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.el-breadcrumb >>> .el-breadcrumb__item:nth-child(3) {
  max-width: 55vw;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
</style>
